import { Capacitor } from '@capacitor/core';
import { useMediaQuery } from './useMediaQuery';
import { useVendorAccess } from './useVendorAccess';

export function useDesktopVendorAccess() {
  const access = useVendorAccess();
  const desktopViewport = useMediaQuery('(min-width: 1024px)');
  const isDesktop = desktopViewport && !Capacitor.isNativePlatform();
  return { ...access, isDesktop, canAccess: isDesktop && access.canAccess };
}
